<template>
  <nav class="bg-gradient-to-r from-[#007FCC] to-[#A55CF0] px-4 py-3">
    <div class="flex items-center justify-between">
      <a href="https://trurating.com/for-shoppers/" class="hover:no-underline">
        <img
          src="~/assets/images/trurating_logo_transparent.svg"
          alt="TruRating Logo"
          class="h-auto select-none w-28"
        />
      </a>
      <div class="flex items-center space-x-2">
        <a
          href="/storefinder"
          class="inline-flex items-center px-3 py-1 text-sm font-medium text-white bg-[#BE89F7] rounded-lg cursor-pointer hover:bg-purple-400 transition-colors duration-200"
        >
          {{ t('storeFinder') }}
        </a>
        <a
          href="https://trurating.com/for-shoppers/"
          class="px-3 py-1 text-sm font-medium text-white rounded-lg hover:bg-[#BE89F7] hover:no-underline"
        >
          {{ t('truRatingHome') }}
        </a>
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
const { t } = useI18n()
</script>
